import { render } from "./CbcAnalyzer.vue?vue&type=template&id=c3bd1f18&scoped=true"
import script from "./CbcAnalyzer.vue?vue&type=script&lang=js"
export * from "./CbcAnalyzer.vue?vue&type=script&lang=js"

import "./CbcAnalyzer.vue?vue&type=style&index=0&id=c3bd1f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3bd1f18"]])

export default __exports__